export interface AccountServer {
  id: string;
  name: string;
  status?: string;
}

/** An account as the list and the edit page receive it. */
export interface AccountRecord {
  id: string;
  accountResponse?: {
    accountName?: string;
    accountStatus?: string;
    apiKey?: string;
    loggingStatus?: string;
    allowDebugOutput?: boolean;
    rateLimitApplies?: boolean;
    rateLimitPerMin?: number;
    rateLimitPerDay?: number;
    primaryServer?: AccountServer;
    secondaryServer?: AccountServer;
  };
  licenseResponse?: { id?: string; licenseName?: string };
  validityTimeFrame?: string;
  isLicenseBlocked?: boolean;
}

/** The logging level by name; the API sends either the name or its number. */
export const loggingLevelOf = (status?: string): string | undefined => {
  switch (status) {
    case '0':
    case '1':
      return 'None';
    case '2':
      return 'Wrong';
    case '3':
      return 'All';
    default:
      return status;
  }
};
